import { HttpErrorResponse } from '@angular/common/http';

export class RefreshAuthenticationError extends Error {
  constructor(public originalError: HttpErrorResponse) {
    super('Background refresh authentication failed.');
    this.name = 'RefreshAuthenticationError';
    Object.setPrototypeOf(this, RefreshAuthenticationError.prototype);
  }
}
